import React from 'react';
import "./Contacts.css"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook } from '@fortawesome/free-brands-svg-icons';
import { useTranslation } from 'react-i18next';

const Contacts = () => {
  const { t } = useTranslation();

  return (
    <div className="contacts-container">
      <div className="contacts-header">
        <h2>{t('contact_us')}</h2>
        <p>{t('we_would_love')}</p>
      </div>

      <div className="contact-cards">
        <div className="contact-card">
          <div className="icon-wrapper">✉️</div>
          <h3>{t('email')}</h3>
          <p>{t('email_us')}</p>
        </div>

        <div className="contact-card">
          <div className="icon-wrapper">📞</div>
          <h3>{t('phone')}</h3>
          <p>{t('call_us')}</p>
        </div>
      </div>

      <div className="social-media-card">
        <h3>{t('follow_us')}</h3>
        <p>{t('follow_facebook_story', 'Follow us on Facebook and share your story!')}</p>
        <div className="social-icons">
          <a href="https://www.facebook.com/profile.php?id=61581409275021" target="_blank" rel="noopener noreferrer" className="fb-button">
            <FontAwesomeIcon icon={faFacebook} /> <span>Facebook</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Contacts;
